import { TFunction } from "i18next";
import { INSPECTIONS_ROUTE, INSPECTION_ROUTE } from "../config/router";

export const pathMapper = (path: string, t: TFunction) => {
    let mappedPath = "";
    switch (path) {
        case INSPECTIONS_ROUTE:
            mappedPath = t("pageHeader.myReports");
            break;
        case INSPECTION_ROUTE:
            mappedPath = t("pageHeader.reports");
            break;
        default:
            mappedPath = path;
    }

    return mappedPath;
};
